// LogoSlideshow.jsx
import React, { useState, useEffect, useRef } from "react";
import styles from "./auth.module.css";

const LogoSlideshow = ({ images, interval = 3000 }) => {
  const [current, setCurrent] = useState(0);
  const length = images.length;
  const timerRef = useRef(null);

  useEffect(() => {
    if (length === 0) return;

    timerRef.current = setInterval(() => {
      setCurrent(prev => (prev + 1) % length);
    }, interval);

    return () => clearInterval(timerRef.current);
  }, [length, interval]);

  // Calculate indices for the four logos
  const getIndices = () => {
    const indices = [];
    for (let i = 0; i < 4; i++) {
      indices.push((current + i) % length);
    }
    return indices;
  };

  const indices = getIndices();

  return (
    <div className={styles.slideshowContainer}>
      {indices.map((index, i) => {
        let positionClass = "";
        if (i === 1) positionClass = styles.center;
        else if (i === 0) positionClass = styles.left;
        else if (i === 2) positionClass = styles.right;
        else if (i === 3) positionClass = styles.farRight;

        return (
          <div key={index} className={`${styles.logoWrapper} ${positionClass}`}>
            <img src={images[index]} alt={`logo-${index}`} className={styles.logoImage} />
          </div>
        );
      })}
    </div>
  );
};

export default LogoSlideshow;
